import { render, staticRenderFns } from "./ThemeButton.vue?vue&type=template&id=0b9a8538&scoped=true&"
import script from "./ThemeButton.vue?vue&type=script&lang=js&"
export * from "./ThemeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9a8538",
  null
  
)

export default component.exports